import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "mt-3" }, "Rules", -1)
const _hoisted_3 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_6 = {
  key: 1,
  class: "row mt-3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "alert alert-primary",
    role: "alert"
  }, "No Rules found")
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "row mt-3 py-3 border-bottom border-top bg-light" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "row mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Name")
], -1)
const _hoisted_15 = { class: "col-10" }
const _hoisted_16 = { class: "row mt-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Field")
], -1)
const _hoisted_18 = { class: "col-10" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<option value=\"\" disabled>Field</option><option value=\"from\">From</option><option value=\"to\">To</option><option value=\"cc\">Cc</option><option value=\"subject\">Subject</option><option value=\"body\">Body</option>", 6)
const _hoisted_25 = [
  _hoisted_19
]
const _hoisted_26 = { class: "row mt-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Pattern (Optional)")
], -1)
const _hoisted_28 = { class: "col-10" }
const _hoisted_29 = { class: "row mt-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Value")
], -1)
const _hoisted_31 = { class: "col-10" }
const _hoisted_32 = { class: "row mt-2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "mb-0" }, "Destination Folder")
], -1)
const _hoisted_34 = { class: "col-10" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Destination folder", -1)
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-12 d-flex justify-content-end mt-3" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "row pt-3" }
const _hoisted_41 = { class: "col" }
const _hoisted_42 = {
  key: 0,
  class: "d-flex mt-5 justify-content-center align-items-center"
}
const _hoisted_43 = {
  key: 1,
  class: "w-100"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Field"),
    /*#__PURE__*/_createElementVNode("th", null, "Pattern"),
    /*#__PURE__*/_createElementVNode("th", null, "Value"),
    /*#__PURE__*/_createElementVNode("th", null, "Move to...")
  ])
], -1)
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col d-flex justify-content-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_VPagination = _resolveComponent("VPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.error != '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.error), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.error == '' && !_ctx.loading && _ctx.rules.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.selectedRule.id !== "" ? "Edit" : "Add New") + " Rule", 1)
          ]),
          (_ctx.selectedRule.id !== '')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                style: {"cursor":"pointer"},
                title: "Stop editing",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.unselectRule()))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "mr-3",
                  icon: ['fas', 'times']
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              required: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedRule.name) = $event))
            }, null, 512), [
              [_vModelText, _ctx.selectedRule.name]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedRule.field) = $event)),
              class: "custom-select no-focus"
            }, _hoisted_25, 512), [
              [_vModelSelect, _ctx.selectedRule.field]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              required: "",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedRule.pattern) = $event))
            }, null, 512), [
              [_vModelText, _ctx.selectedRule.pattern]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              required: "",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedRule.value) = $event))
            }, null, 512), [
              [_vModelText, _ctx.selectedRule.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedRule.destinationFolderId) = $event)),
              class: "custom-select no-focus"
            }, [
              _hoisted_35,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (fld) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: fld.id,
                  key: fld.id
                }, _toDisplayString(fld.name), 9, _hoisted_36))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selectedRule.destinationFolderId]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            (_ctx.selectedRule.id !== '')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-danger mr-1",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deleteRule && _ctx.deleteRule(...args)), ["prevent"]))
                }, " Delete Rule "))
              : _createCommentVNode("", true),
            (_ctx.selectedRule.id === '')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-primary",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addRule && _ctx.addRule(...args)), ["prevent"])),
                  disabled: !_ctx.validateRule()
                }, " Add Rule ", 8, _hoisted_39))
              : _createCommentVNode("", true),
            (_ctx.selectedRule.id !== '')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn btn-primary",
                  onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateRule && _ctx.updateRule(...args)), ["prevent"]))
                }, " Update Rule "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        (_ctx.loading && _ctx.error.length != 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
              _createVNode(_component_font_awesome_icon, {
                class: "text-primary",
                icon: ['fas', 'spinner'],
                size: "lg",
                spin: ""
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.loading && _ctx.rules.length > 0)
          ? (_openBlock(), _createElementBlock("table", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rules, (rl) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: rl.id,
                    class: _normalizeClass(rl.id === _ctx.selectedRule.id ? 'selected-row' : ''),
                    onClick: _withModifiers(($event: any) => (_ctx.selectedRule = { ...rl }), ["prevent"])
                  }, [
                    _createElementVNode("td", null, _toDisplayString(rl.name), 1),
                    _createElementVNode("td", null, _toDisplayString(rl.field), 1),
                    _createElementVNode("td", null, _toDisplayString(rl.pattern), 1),
                    _createElementVNode("td", null, _toDisplayString(rl.value), 1),
                    _createElementVNode("td", null, _toDisplayString(rl.destinationFolder.name), 1)
                  ], 10, _hoisted_45))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_VPagination, {
              pagination: _ctx.rulesPagination,
              "onUpdate:pagination": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.rulesPagination) = $event)),
              onPageChanged: _cache[10] || (_cache[10] = (page) => (_ctx.currentPage = page))
            }, null, 8, ["pagination"])
          ])
        ])
      ])
    ])
  ]))
}